import state from "./moduleHullInsuranceAddReportState.js";
import mutations from "./moduleHullInsuranceAddReportMutations.js";
import actions from "./moduleHullInsuranceAddReportActions.js";
import getters from "./moduleHullInsuranceAddReportGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
